<template>
  <div class="calendar_marquees">
    <div class="calendar_marquees_title">VIEW: </div>
    <div class="calendar_marquees_actions">
      <div id="calendar_marquees_calendar_active" class="calendar_marquees_action" :class="type === 'calendar' ? 'calendar_marquees_action__active' : ''" @click="changeType('calendar')">
        <svg-icon name="calendar" :color="type === 'calendar' ? '#ffffff' : '#EE733A'" />
        CALENDAR
      </div>
      <div id="calendar_marquees_grid_active" class="calendar_marquees_action" :class="type === 'grid' ? 'calendar_marquees_action__active' : ''" @click="changeType('grid')">
        <svg-icon name="four-squares" />
        GRID
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '../shared/icons/index.vue';
import { EventBus, EVENT_CALENDAR_FORCE_SHOW, CALENDAR_MARQUEES_SHOW_GRID } from '../../event-bus';

export default {
  components: { SvgIcon },
  props: {
    type: {
      type: String,
      default: () => {
        return 'calendar';
      },
    },
  },
  methods: {
    changeType(type) {
      this.$emit('change-type', type);
      if (type === 'calendar') {
        EventBus.$emit(EVENT_CALENDAR_FORCE_SHOW);
      } else if (type === 'grid') {
        EventBus.$emit(CALENDAR_MARQUEES_SHOW_GRID);
      }
    },
  },
};
</script>
<style lang="scss">
    @import "../../styles/landing/calendar.scss";
</style>
